import { z } from "zod";

import { fetchWithError, useParsedQueries, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { paginatedSchema } from "../pagination";

import { baseAssetWithTimeseriesSchema } from "./assetsBase";

export const manholeListItemSchema = baseAssetWithTimeseriesSchema.extend({
  surface_level: z.number().nullable(),
  drainage_area: z.number().nullable(),
  material: z.string(),
  width: z.number().nullable(),
  length: z.number().nullable(),
  shape: z.string(),
  bottom_level: z.number().nullable(),
  water_consumption: z.number().nullable(),
});

export type ManholeListItem = z.infer<typeof manholeListItemSchema>;

export const manholeListSchema = paginatedSchema(manholeListItemSchema);
export type ManholeList = z.infer<typeof manholeListSchema>;

export const manholeSchema = manholeListItemSchema;
export type Manhole = z.infer<typeof manholeSchema>;

export function useManholes(params = {}) {
  const url = combineUrlAndParams("/api/v4/manholes/", params);
  return useParsedQuery<ManholeList>(
    ["lizard-api-v4", "manholes", url],
    () => fetchWithError(url),
    (json: unknown) => manholeListSchema.parse(json)
  );
}

export function useManhole(id: number) {
  return useParsedQuery<Manhole>(
    ["lizard-api-v4", "manholes", id],
    () => fetchWithError(`/api/v4/manholes/${id}/`),
    (json: unknown) => manholeSchema.parse(json)
  );
}

export function useMultipleManholes(ids: number[]) {
  return useParsedQueries(
    ids.map((id) => {
      return {
        queryKey: ["lizard-api-v4", "manholes", id],
        fetchFunction: () => fetchWithError(`/api/v4/manholes/${id}/`),
        parseFunction: (json: unknown) => manholeSchema.parse(json),
      };
    })
  );
}
